/** Sections available */
export const FORECASTS = {
  slug: 'forecasts',
  singularSlug: 'forecast',
  checkbox: 'forecasts_and_costs',
  name: 'Forecasts',
  service: 'Forecasting',
  singularName: 'Forecast',
  seo: {
    description:
      'Benchmark Mineral Intelligence produces expert quarterly forecasts for Lithium, Graphite, Cobalt, Nickel, Anode, Cathode, Natural Graphite, Recycling, Solid State, and Synthetic Graphite out to 2040. Subscribe for access.',
  },
} as const

export const SOURCE = {
  slug: 'https://source.benchmarkminerals.com',
  name: 'Source',
  service: 'Membership',
} as const

export const CONSULTANCY = {
  slug: 'consultancy',
  name: 'Consultancy',
  service: 'Consultancy',
} as const

export const MARKET_ASSESSMENTS = {
  slug: 'market-assessments',
  checkbox: 'market-assessments',
  name: 'Market Assessments',
  service: 'Market Assessments',
  singularName: 'Market Assessment',
} as const

export const PRICE_ASSESSMENTS = {
  slug: 'price-assessments',
  checkbox: 'price-assessments',
  name: 'Price Assessments',
  singularName: 'Price Assessment',
  service: 'Price Assessments',
  seo: {
    description:
      'Price assessments for the lithium ion battery supply chain. lithium, cobalt, graphite & nickel. Subscribe for price assessments & more.',
  },
} as const

export const ESG = {
  slug: 'esg',
  singularSlug: 'sustainability',
  name: 'Sustainability',
  checkbox: 'esg',
  service: 'ESG',
  singularName: 'Sustainability',
  seo: {
    description:
      "Having emerged out of the investor space, ESG (environment, social and governance) is a tool for companies to monitor and report on their sustainability performance. Good ESG practices and disclosure ensure the conduct of an organisation does not jeopardise future generation's access to resources and operates with social license",
  },
} as const

export const MARKET = {
  slug: 'market',
  name: 'Markets',
  service: 'Market',
  seo: {
    description:
      'Benchmark Mineral Intelligence provides market intelligence for the lithium ion battery supply chain. Subscribe for market intelligence & more.',
  },
} as const

export const AVAILABLE_SERVICES = [
  FORECASTS,
  SOURCE,
  CONSULTANCY,
  MARKET_ASSESSMENTS,
  PRICE_ASSESSMENTS,
  ESG,
  MARKET,
] as const

/** Subscriptions */
export const PA_SUBSCRIPTION_PREFIX = 'pricing-'
/** Subscriptions available */
export const SUBSCRIPTION_FORECASTS_ANODE = 'forecast-anode'
export const SUBSCRIPTION_FORECASTS_LITHIUM_ION_BATTERIES =
  'forecast-battery-and-gigafactory'
export const SUBSCRIPTION_FORECASTS_CATHODE = 'forecast-cathode'
export const SUBSCRIPTION_FORECASTS_COBALT = 'forecast-cobalt'
export const SUBSCRIPTION_FORECASTS_LITHIUM = 'forecast-lithium'

export const SUBSCRIPTION_FORECASTS_COPPER = 'forecast-copper'
export const SUBSCRIPTION_BRIEFING_COPPER = 'copper-briefing'
export const SUBSCRIPTION_SERVICE_COPPER = 'service-copper'

export const SUBSCRIPTION_FORECASTS_SILICON_ANODE = 'forecast-silicon-anode'
export const SUBSCRIPTION_FORECASTS_NATURAL_GRAPHITE =
  'forecast-natural-graphite'
export const SUBSCRIPTION_FORECASTS_NICKEL = 'forecast-nickel'
export const SUBSCRIPTION_FORECASTS_SOLID_STATE = 'forecast-solid-state'
export const SUBSCRIPTION_FORECASTS_SYNTHETIC_GRAPHITE =
  'forecast-synthetic-graphite'
export const SUBSCRIPTION_FORECASTS_RECYCLING = 'forecast-recycling'
export const SUBSCRIPTION_FORECASTS_NEW_TECHNOLOGY = 'forecast-new-technology'
export const SUBSCRIPTION_SOURCE_SUBSCRIBER = 'subscriber'
export const SUBSCRIPTION_MARKET_ASSESSMENTS_GIGAFACTORY_ASSESSMENT =
  'market-assessment-battery-and-gigafactory'
export const SUBSCRIPTION_MARKET_ASSESSMENTS_PRECURSOR_ASSESSMENT =
  'market-assessment-precursor'
export const SUBSCRIPTION_PRICE_ASSESSMENTS_LITHIUM = `${PA_SUBSCRIPTION_PREFIX}lithium`
export const SUBSCRIPTION_PRICE_ASSESSMENTS_COBALT = `${PA_SUBSCRIPTION_PREFIX}cobalt`
export const SUBSCRIPTION_PRICE_ASSESSMENTS_NICKEL = `${PA_SUBSCRIPTION_PREFIX}nickel`
export const SUBSCRIPTION_PRICE_ASSESSMENTS_NATURAL_GRAPHITE = `${PA_SUBSCRIPTION_PREFIX}natural-graphite`
export const SUBSCRIPTION_PRICE_ASSESSMENTS_SYNTHETIC_GRAPHITE = `${PA_SUBSCRIPTION_PREFIX}synthetic-graphite`
export const SUBSCRIPTION_PRICE_ASSESSMENTS_LITHIUM_ION_BATTERIES = `${PA_SUBSCRIPTION_PREFIX}battery-cell`
export const SUBSCRIPTION_PRICE_ASSESSMENTS_RARE_EARTHS = `${PA_SUBSCRIPTION_PREFIX}rare-earths`
export const SUBSCRIPTION_PRICE_ASSESSMENTS_ANODE = `${PA_SUBSCRIPTION_PREFIX}anode`
export const SUBSCRIPTION_PRICE_ASSESSMENTS_CATHODE = `${PA_SUBSCRIPTION_PREFIX}cathode`
export const SUBSCRIPTION_PRICE_ASSESSMENTS_BLACK_MASS = `${PA_SUBSCRIPTION_PREFIX}black-mass`
export const SUBSCRIPTION_PRICE_ASSESSMENTS_ALL_PRICES = `${PA_SUBSCRIPTION_PREFIX}all-prices`
export const SUBSCRIPTION_ESG_LITHIUM = 'esg-lithium'
export const SUBSCRIPTION_ESG_LITHIUM_ION_BATTERIES = 'esg-battery-database'
export const SUBSCRIPTION_ESG_COBALT = 'esg-cobalt'
export const SUBSCRIPTION_ESG_BATTERY_EMISSIONS_ANALYSER =
  'esg-battery-emissions-analyser'
export const SUBSCRIPTION_ESG_NICKEL = 'esg-nickel'
export const SUBSCRIPTION_ESG_NATURAL_GRAPHITE = 'esg-natural-graphite'
export const SUBSCRIPTION_ESG_SYNTHETIC_GRAPHITE = 'esg-synthetic-graphite'
export const SUBSCRIPTION_ESG_GRAPHITE = 'esg-graphite'
export const SUBSCRIPTION_ESG_RARE_EARTHS = 'esg-rare-earths'
export const SUBSCRIPTION_FORECASTS_RARE_EARTHS = 'forecast-rare-earths'
export const SUBSCRIPTION_ALL = 'allSubscriptions'
export const SUBSCRIPTION_FORECASTS_MANGANESE = 'forecast-manganese'
export const SUBSCRIPTION_FORECASTS_PHOSPHATE = 'forecast-phosphate'
export const SUBSCRIPTION_FORECASTS_FLUORSPAR = 'forecast-fluorspar'
export const SUBSCRIPTION_FORECASTS_SODIUM_ION_BATTERIES =
  'forecast-sodium-ion-batteries'
export const SUBSCRIPTION_PRICING_ALL_PRICES = 'pricing-all-prices'

export const SIGN_IN = 'Sign In'

export const PRICING_ALL_PRICES = {
  slug: 'all-prices-subscription',
  name: 'All Prices',
  iconLine: 'AllPrices',
  menu: 'All Prices',
} as const

/** Services available */
export const LITHIUM = {
  slug: 'lithium',
  hasMarketingPage: false,
  hasChart: true,
  slugForecast: 'lithium',
  checkbox: 'lithium',
  name: 'Lithium',
  simplifiedName: 'Lithium',
  capacityName: 'Lithium',
  category: 'lithium',
  categoryReportPricing: 'lithium',
  categoryReportForecast: 'forecast-lithium',
  categoryReportEsg: 'esg-lithium',
  categoryReportEsgAuxiliary: null,
  mineralId: 2,
  menu: 'Lithium',
  sidebar: 'Lithium',
  iconLine: 'Lithium',
  iconColor: 'lithium-logo',
  seo: {
    priceAssessments: {
      reportDescription:
        'Find every Lithium Price Assessment report obtained by the Benchmark Mineral Intelligence in the past weeks or months.',
    },
  },
} as const

export const COPPER = {
  slug: 'copper',
  hasMarketingPage: true,
  hasChart: false,
  slugForecast: null,
  checkbox: 'copper',
  name: 'Copper',
  simplifiedName: 'copper',
  capacityName: 'copper',
  category: 'copper',
  categoryReportPricing: 'copper-briefing',
  categoryReportForecast: 'forecast-copper',
  categoryReportEsg: 'esg-copper',
  categoryReportEsgAuxiliary: null,
  mineralId: 2,
  menu: 'Copper',
  sidebar: 'Copper',
  iconLine: 'Copper',
  iconColor: 'copper-logo',
  seo: {
    priceAssessments: {
      reportDescription:
        'Find every Lithium Price Assessment report obtained by the Benchmark Mineral Intelligence in the past weeks or months.',
    },
  },
} as const

export const COBALT = {
  slug: 'cobalt',
  hasMarketingPage: false,
  hasChart: true,
  slugForecast: 'cobalt',
  checkbox: 'cobalt',
  name: 'Cobalt',
  simplifiedName: 'Cobalt',
  capacityName: 'Cobalt',
  category: 'cobalt',
  categoryReportPricing: 'cobalt',
  categoryReportForecast: 'forecast-cobalt',
  categoryReportEsg: 'esg-cobalt',
  categoryReportEsgAuxiliary: 'esg-nickel-and-cobalt',
  mineralId: 3,
  menu: 'Cobalt',
  sidebar: 'Cobalt',
  iconLine: 'Cobalt',
  iconColor: 'cobalt-logo',
  seo: {
    priceAssessments: {
      reportDescription:
        'Find every Cobalt Price Assessment report obtained by the Benchmark Mineral Intelligence in the past weeks or months.',
    },
  },
} as const

export const BATTERY_EMISSIONS_ANALYSER = {
  slug: 'battery-emissions-analyser',
  hasMarketingPage: false,
  hasChart: false,
  slugForecast: 'battery-emissions-analyser',
  name: 'Battery Emissions Analyser',
  simplifiedName: 'Battery Emissions Analyser',
  capacityName: 'Battery Emissions Analyser',
  category: 'battery-emissions-analyser',
  categoryReportPricing: 'battery-emissions-analyser',
  categoryReportForecast: 'forecast-battery-emissions-analyser',
  categoryReportEsg: 'esg-battery-emissions-analyser',
  categoryReportEsgAuxiliary: null,
  mineralId: 3,
  menu: 'Battery Emissions Analyser',
  sidebar: 'Battery Emissions Analyser',
  iconLine: 'BEA',
  iconColor: 'cobalt-logo',
  description: `
    Supports at all stages of the supply chain with carbon intensity analysis for key battery chemistries, raw materials and production locations. This tool and service is provided as part of Benchmark’s ESG Reports for Lithium, Cobalt, Nickel and Graphite, or as a standalone service.
  `,
  seo: {
    priceAssessments: {
      reportDescription:
        'Find every Battery Emissions Analyser Price Assessment report obtained by the Benchmark Mineral Intelligence in the past weeks or months.',
    },
  },
} as const

export const NICKEL = {
  slug: 'nickel',
  hasMarketingPage: false,
  hasChart: true,
  slugForecast: 'nickel',
  checkbox: 'nickel',
  name: 'Nickel',
  simplifiedName: 'Nickel',
  capacityName: 'Nickel',
  category: 'nickel',
  categoryReportPricing: 'nickel',
  categoryReportForecast: 'forecast-nickel',
  categoryReportEsg: 'esg-nickel',
  categoryReportEsgAuxiliary: 'esg-nickel-and-cobalt',
  mineralId: 4,
  menu: 'Nickel',
  sidebar: 'Nickel',
  iconLine: 'Nickel',
  iconColor: 'nickel-logo',
  seo: {
    priceAssessments: {
      reportDescription:
        'Find every Nickel Price Assessment report obtained by the Benchmark Mineral Intelligence in the past weeks or months.',
    },
  },
} as const

export const SODIUM_ION_BATTERIES = {
  slug: 'sodium-ion-batteries',
  hasMarketingPage: false,
  hasChart: false,
  slugForecast: 'sodium-ion-batteries',
  checkbox: 'sodium-ion-batteries',
  name: 'Sodium ion Batteries',
  simplifiedName: 'Sodium ion',
  category: 'sodium-ion-batteries',
  categoryReportPricing: 'sodium-ion-batteries',
  categoryReportForecast: 'forecast-sodium-ion-batteries',
  categoryReportEsg: 'esg-sodium-ion-batteries',
  categoryReportEsgAuxiliary: null,
  reportSlug: 'sodium-ion-batteries',
  mineralId: null,
  menu: 'Sodium Ion Batteries',
  sidebar: 'Sodium ion Batteries',
  iconLine: 'SodiumIonBatteries',
  iconSquare: 'SodiumIonBatteries',
  iconColor: 'SodiumIonBatteries',
  seo: {
    marketAssessments: {
      capacities:
        'Headquartered: Download chart as image Cathode Producers: Total Capacity Pipeline: tpa',
      reportDescription:
        'Headquartered: Download chart as image Cathode Producers: Total Capacity Pipeline: tpa',
    },
  },
} as const

export const ELECTROLYTE = {
  name: 'Electrolyte',
  simplifiedName: 'Electrolyte',
  iconLine: 'Electrolyte',
} as const

export const NATURAL_GRAPHITE = {
  slug: 'natural-graphite',
  hasMarketingPage: false,
  hasChart: true,
  slugForecast: 'natural-graphite',
  checkbox: 'natural-graphite',
  name: 'Natural Graphite',
  simplifiedName: 'Natural Graphite',
  capacityName: 'Natural Graphite',
  category: 'natural-graphite',
  categoriesArticles: ['graphite', 'natural-graphite'],
  categoryReportPricing: 'natural-graphite',
  categoryReportForecast: 'forecast-natural-graphite',
  categoryReportEsg: 'esg-synthetic-graphite',
  categoryReportEsgAuxiliary: null,
  mineralId: 1,
  menu: 'Natural Graphite',
  sidebar: 'Natural Graphite',
  iconLine: 'FlakeGraphite',
  iconColor: 'graphite-logo',
  seo: {
    priceAssessments: {
      reportDescription:
        'Find every Natural Graphite Price Assessment report obtained by the Benchmark Mineral Intelligence in the past weeks or months.',
    },
  },
} as const

export const SYNTHETIC_GRAPHITE = {
  slug: 'synthetic-graphite',
  hasMarketingPage: false,
  hasChart: true,
  slugForecast: 'synthetic-graphite',
  checkbox: 'synthetic-graphite',
  name: 'Synthetic Graphite',
  altName: 'Anode Coke',
  simplifiedName: 'Synthetic Graphite',
  capacityName: 'Synthetic Graphite',
  category: 'synthetic-graphite',
  categoriesArticles: ['graphite', 'synthetic-graphite'],
  categoryReportPricing: 'synthetic-graphite',
  categoryReportForecast: 'forecast-synthetic-graphite',
  categoryReportEsg: 'esg-synthetic-graphite',
  categoryReportEsgAuxiliary: null,
  mineralId: 5,
  menu: 'Synthetic Graphite',
  sidebar: 'Synthetic Graphite',
  iconLine: 'SyntheticGraphite',
  iconColor: 'synthetic-graphite-logo',
  seo: {
    priceAssessments: {
      reportDescription:
        'Find every Synthetic Graphite Price Assessment report obtained by the Benchmark Mineral Intelligence in the past weeks or months.',
    },
  },
} as const

export const ANODE = {
  slug: 'anode',
  hasMarketingPage: false,
  hasChart: true,
  slugForecast: 'anode',
  methodology: 'download',
  checkbox: 'anode',
  name: 'Anode',
  simplifiedName: 'Anode',
  category: 'anode',
  categoryReportPricing: 'anode',
  categoryReportEsg: 'esg-anode',
  categoryReportEsgAuxiliary: null,
  categoryReportForecast: 'forecast-anode',
  mineralId: 6,
  menu: 'Anode',
  sidebar: 'Anode',
  iconLine: 'Anodes',
  iconSquare: 'Anodes',
  iconColor: 'anode-logo',
  seo: {
    priceAssessments: {
      reportDescription:
        'Find every Anode Price Assessment report obtained by the Benchmark Mineral Intelligence in the past weeks or months.',
      capacities:
        'Headquartered: Download chart as image Anode Producers: Total Capacity Pipeline: tpa',
    },
  },
} as const

export const CATHODE = {
  slug: 'cathode',
  hasMarketingPage: false,
  hasChart: true,
  slugForecast: 'cathode',
  methodology: 'download',
  name: 'Cathode',
  simplifiedName: 'Cathode',
  checkbox: 'cathode',
  category: 'cathode',
  categoryReportPricing: 'cathode',
  categoryReportEsg: 'esg-cathode',
  categoryReportEsgAuxiliary: null,
  categoryReportForecast: 'forecast-cathode',
  mineralId: 7,
  menu: 'Cathode',
  sidebar: 'Cathode',
  iconLine: 'Cathodes',
  iconSquare: 'Cathodes',
  iconColor: 'cathode-logo',
  seo: {
    priceAssessments: {
      reportDescription:
        'Find every Cathode Price Assessment report obtained by the Benchmark Mineral Intelligence in the past weeks or months.',
      capacities:
        'Headquartered: Download chart as image Cathode Producers: Total Capacity Pipeline: tpa',
    },
  },
} as const

export const RECYCLING = {
  slug: 'recycling',
  hasMarketingPage: true,
  hasChart: true,
  slugForecast: 'recycling',
  name: 'Recycling',
  simplifiedName: 'Recycling',
  serviceBasePath: 'recycling',
  reportSlug: 'recycling',
  capacityName: 'Recycling',
  category: 'recycling',
  categoryReportPricing: 'recycling',
  categoriesArticles: ['black-mass', 'recycling'],
  categoryReportForecast: 'forecast-recycling',
  categoryReportEsg: 'esg-recycling',
  categoryReportEsgAuxiliary: null,
  mineralId: 9,
  menu: 'Recycling',
  sidebar: 'Recycling',
  iconLine: 'Recycling',
  iconColor: 'blackMass-logo',
  seo: {
    priceAssessments: {
      reportDescription:
        'Find every Recycling Price Assessment report obtained by the Benchmark Mineral Intelligence in the past weeks or months.',
    },
  },
} as const

export const SILICON_ANODE = {
  slug: 'silicon-anode',
  hasMarketingPage: false,
  hasChart: false,
  slugForecast: 'silicon-anode',
  checkbox: 'silicon-anode',
  name: 'Silicon Anode',
  simplifiedName: 'Silicon Anode',
  capacityName: 'Silicon Anode',
  category: 'silicon-anode',
  categoryReportPricing: 'silicon-anode',
  categoryReportForecast: 'forecast-silicon-anode',
  categoryReportEsg: 'esg-silicon-anode',
  categoryReportEsgAuxiliary: null,
  mineralId: 2,
  menu: 'Silicon Anode',
  sidebar: 'Silicon Anode',
  iconLine: 'SiliconAnode',
  iconColor: 'silicon-anode',
  seo: {
    priceAssessments: {
      reportDescription:
        'Find every Silicon Anode Price Assessment report obtained by the Benchmark Mineral Intelligence in the past weeks or months.',
    },
  },
} as const

export const SOLID_STATE = {
  slug: 'solid-state',
  hasMarketingPage: false,
  hasChart: false,
  slugForecast: 'solid-state',
  name: 'Solid-state Batteries',
  checkbox: 'solid-state-batteries',
  simplifiedName: 'Solid State',
  capacityName: 'Solid State',
  category: 'solid-state',
  categoryReportPricing: null,
  categoryReportForecast: 'forecast-solid-state',
  categoryReportEsg: 'esg-solid-state',
  categoryReportEsgAuxiliary: null,
  mineralId: null,
  menu: 'Solid State',
  sidebar: 'Solid-state Batteries',
  iconLine: 'SolidState',
  iconColor: 'solid-state',
  seo: {
    priceAssessments: {
      reportDescription:
        'Find every Solid State Price Assessment report obtained by the Benchmark Mineral Intelligence in the past weeks or months.',
    },
  },
} as const

export const NEW_TECHNOLOGY = {
  slug: 'new-technology',
  hasMarketingPage: true,
  hasChart: false,
  slugForecast: 'new-technology',
  name: 'New Technology',
  simplifiedName: 'New Technology',
  serviceBasePath: 'new-technology',
  reportSlug: 'new-technology',
  capacityName: 'New Technology',
  category: 'new-technology',
  categoryReportPricing: 'new-technology',
  categoriesArticles: [SOLID_STATE.slug, SILICON_ANODE.slug],
  categoryReportForecast: 'forecast-new-technology',
  categoryReportEsg: 'esg-recycling',
  categoryReportEsgAuxiliary: null,
  mineralId: 9,
  menu: 'New Technology',
  sidebar: 'New Technology',
  iconLine: 'NewTechnology',
  iconColor: 'new-technology-logo',
  seo: {
    priceAssessments: {
      reportDescription:
        'Find every New Technology Price Assessment report obtained by the Benchmark Mineral Intelligence in the' +
        ' past weeks or months.',
    },
  },
} as const

export const LITHIUM_ION_BATTERIES = {
  alternativeSlug: 'battery-gigafactory',
  slug: 'lithium-ion-batteries',
  hasMarketingPage: true,
  hasChart: true,
  slugForecast: 'lithium-ion-batteries',
  methodology: 'redirect',
  redirectUrl: '/methodologies/market-assessments/gigafactories',
  checkbox: 'lithium-ion-batteries',
  name: 'Battery & Gigafactory',
  simplifiedName: 'Battery & Gigafactory',
  capacityName: 'Battery & Gigafactory',
  capacitySimplifiedName: 'Gigafactory',
  capacitySlug: 'gigafactory',
  category: 'lithium-ion-batteries',
  categoriesArticles: [
    'gigafactories',
    'battery-cell',
    'lithium-ion-batteries',
  ],
  categoryReportPricing: 'lithium-ion-batteries',
  categoryReportForecast: 'forecast-battery-database',
  categoryReportEsg: 'esg-lithium-ion-batteries',
  categoryReportEsgAuxiliary: null,
  mineralId: 8,
  menu: 'Battery & Gigafactory',
  sidebar: 'Battery & Gigafactory',
  iconLine: 'BatteryDatabase',
  iconSquare: 'BatteryDatabase',
  iconColor: 'battery-cells-logo',
  forecasts: {
    name: 'Battery & Gigafactory',
  },
  seo: {
    priceAssessments: {
      reportDescription:
        'Find every Battery & Gigafactory Price Assessment report obtained by the Benchmark Mineral Intelligence in the past weeks or months.',
      capacities:
        'Headquartered: Download chart as image Gigafactory Producers: Total Capacity Pipeline: GWh',
    },
  },
} as const

export const GIGAFACTORY_ASSESSMENT = {
  slug: 'gigafactory-assessment',
  hasMarketingPage: false,
  hasChart: true,
  slugForecast: 'gigafactory-assessment',
  name: 'Lithium ion Battery Gigafactory Assessment',
  simplifiedName: 'Gigafactory',
  checkbox: 'gigafactory-assessment',
  capacityName: 'Lithium ion Battery',
  capacitySlug: 'gigafactory',
  category: 'gigafactory',
  categoryReportPricing: 'gigafactory',
  categoryReportForecast: null,
  mineralId: null,
  menu: 'Gigafactory Assessment',
  sidebar: 'Gigafactory Assessment',
  iconLine: 'BatteryDatabase',
  iconColor: 'battery-cells-logo',
  unauthorizedTitle: 'Lithium ion Battery Gigafactory Assessment',
  seo: {
    priceAssessments: {
      reportDescription:
        'Find every Gigafactory Price Assessment report obtained by the Benchmark Mineral Intelligence in the past weeks or months.',
    },
    marketAssessments: {
      reportDescription:
        'Find every Gigafactory Market Assessment report obtained by the Benchmark Mineral Intelligence in the past weeks or months.',
      capacities:
        'Headquartered: Download chart as image Gigafactory Producers: Total Capacity Pipeline: tpa',
    },
  },
} as const

export const RARE_EARTHS = {
  slug: 'rare-earths',
  hasMarketingPage: false,
  hasChart: true,
  slugForecast: 'rare-earths',
  checkbox: 'rare-earths',
  name: 'Rare Earths',
  simplifiedName: 'Rare Earths',
  capacityName: 'Rare Earths',
  category: 'rare-earths',
  categoryReportPricing: 'rare-earths',
  categoryReportForecast: 'forecast-rare-earths',
  categoryReportEsg: 'esg-rare-earths',
  categoryReportEsgAuxiliary: null,
  mineralId: null,
  menu: 'Rare Earths',
  sidebar: 'Rare Earths',
  iconLine: 'motor',
  iconColor: 'rare-earths-logo',
  forecasts: {
    name: 'Rare Earths',
  },
  seo: {
    priceAssessments: {
      reportDescription:
        'Find every Rare Earths Price Assessment report obtained by the Benchmark Mineral Intelligence in the past weeks or months.',
    },
  },
} as const

export const GRAPHITE = {
  slug: 'graphite',
  hasMarketingPage: false,
  hasChart: true,
  slugForecast: 'graphite',
  name: 'Graphite',
  simplifiedName: 'Graphite',
  capacityName: 'Graphite',
  category: 'graphite',
  categoryReportPricing: 'graphite',
  categoryReportEsg: 'esg-graphite',
  categoryReportEsgAuxiliary: null,
  mineralId: null,
  menu: 'Graphite',
  sidebar: 'Graphite',
  iconLine: 'SyntheticGraphite',
  iconColor: 'graphite-logo',
  seo: {
    priceAssessments: {
      reportDescription:
        'Find every Graphite Price Assessment report obtained by the Benchmark Mineral Intelligence in the past weeks or months.',
    },
  },
} as const

export const BLACK_MASS = {
  slug: 'black-mass',
  hasMarketingPage: true,
  hasChart: true,
  slugForecast: 'recycling',
  serviceBasePath: 'recycling',
  reportSlug: 'recycling',
  name: 'Black Mass',
  simplifiedName: 'Black Mass',
  category: 'black-mass',
  categoryReportPricing: 'recycling',
  categoriesArticles: ['black-mass', 'recycling'],
  mineralId: 9,
  menu: 'Black Mass',
  sidebar: 'Black Mass',
  iconLine: 'blackMass',
  iconColor: 'blackMass-logo',
  seo: {
    priceAssessments: {
      reportDescription:
        'Find every Black Mass Price Assessment report obtained by the Benchmark Mineral Intelligence in the past weeks or months.',
    },
  },
} as const

export const MANGANESE = {
  slug: 'manganese',
  hasMarketingPage: false,
  hasChart: false,
  slugForecast: 'manganese',
  checkbox: 'manganese',
  name: 'Manganese',
  titleForecast: 'Manganese Sulphate Market Outlook',
  simplifiedName: 'Manganese',
  category: 'manganese',
  categoryReportPricing: null,
  categoryReportForecast: 'forecast-manganese',
  categoryReportEsg: 'esg-manganese',
  categoryReportEsgAuxiliary: null,
  mineralId: null,
  menu: 'Manganese',
  sidebar: 'Manganese',
  overviewName: 'Manganese Sulphate',
  iconLine: 'Manganese',
  iconColor: 'manganese',
  forecasts: {
    name: 'Manganese',
  },
  seo: {
    priceAssessments: {
      reportDescription:
        'Find every Manganese Sulphate Market Outlook Price Assessment report obtained by the Benchmark Mineral Intelligence in the past weeks or months.',
    },
  },
} as const

export const PHOSPHATE = {
  slug: 'phosphate',
  hasMarketingPage: false,
  hasChart: false,
  slugForecast: 'phosphate',
  checkbox: 'phosphate',
  name: 'Phosphate',
  titleForecast: 'Phosphoric Acid Market Outlook',
  simplifiedName: 'Phosphate',
  capacityName: 'Phosphate',
  category: 'phosphate',
  categoryReportPricing: null,
  categoryReportForecast: 'forecast-phosphate',
  categoryReportEsg: 'esg-phosphate',
  categoryReportEsgAuxiliary: null,
  mineralId: null,
  menu: 'Phosphate',
  sidebar: 'Phosphate',
  overviewName: 'Phosphoric Acid',
  iconLine: 'Phosphate',
  iconColor: 'phosphate',
  forecasts: {
    name: 'Phosphate',
  },
  seo: {
    priceAssessments: {
      reportDescription:
        'Find every Phosphoric Acid Market Outlook Price Assessment report obtained by the Benchmark Mineral Intelligence in the past weeks or months.',
    },
  },
} as const

export const FLUORSPAR = {
  slug: 'fluorspar',
  hasMarketingPage: false,
  hasChart: false,
  slugForecast: 'fluorspar',
  checkbox: 'fluorspar',
  name: 'Fluorspar',
  titleForecast: 'Fluorspar Market Outlook',
  category: 'fluorspar',
  categoryReportPricing: null,
  categoryReportEsg: 'esg-fluorspar',
  categoryReportEsgAuxiliary: null,
  categoryReportForecast: 'forecast-fluorspar',
  mineralId: null,
  menu: 'Fluorspar',
  sidebar: 'Fluorspar',
  iconLine: 'Fluorspar',
  iconColor: 'fluorspar',
  unauthorizedTitle: 'Precursor Cathode Active Material Assessment',
  seo: {
    priceAssessments: {
      reportDescription:
        'Find every Fluorspar Market Outlook Price Assessment report obtained by the Benchmark Mineral Intelligence in the past weeks or months.',
    },
    marketAssessments: {
      reportDescription:
        'Find every Fluorspar Market Outlook Market Assessment report obtained by the Benchmark Mineral Intelligence in the past weeks or months.',
      capacities:
        'Headquartered: Download chart as image Gigafactory Producers: Total Capacity Pipeline: tpa',
    },
  },
} as const

export const PRICE_DASHBOARD = {
  membership: 'pricing-all-prices',
  slug: 'price-dashboard',
  membershipName: 'All Prices',
  name: 'Price Dashboard',
  simplifiedName: 'Price Dashboard',
  menu: 'Price Dashboard',
  sidebar: 'Price Dashboard',
  iconLine: 'lineChart',
  iconColor: 'lithium-logo',
} as const

export const EXCEL_ADD_IN = {
  slug: 'excel-add-in',
  name: 'Excel Add-In',
} as const

export const NEWSLETTER_SENTENCES = [
  'Be informed of everything that happens at Benchmark',
  'Regular content on critical minerals, lithium ion batteries, gigafactories, electric vehicles, energy storage, rare earths and permanent magnets',
  'Free In Person & Online Events',
  'New Product Launches',
]

export const NEWSLETTERS = [
  {
    title: 'Benchmark Newsletter',
    subTitle: 'Mine to Grid Monthly',
    description:
      '360° coverage of the entire depth and breadth of energy transition supply chains. Your trusted monthly update on raw material markets, pricing trends, policy shifts, and key developments across downstream sectors',
    img: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto:best,w_700/v1747758241/assets/newsletter/Graph_BG_Overlay_uojjm2.png',
    alt: 'Benchmark Newsletter',
  },
  {
    title: 'Price Spotlight',
    description:
      'Stay up to date with EV battery supply chain price indexes, derived from Benchmark’s world-leading Price Assessments, direct to your inbox every week.',
    img: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto:best,w_700/v1747758237/assets/newsletter/Graph_BG_Overlay_1_taqohm.png',
    alt: 'Price Spotlight Newsletter',
  },
  {
    title: 'Copper Newsletter',
    description:
      'Keep ahead of the curve with weekly updates on the evolving role copper plays in the energy transition, copper prices, market dynamics and firsthand insights from Benchmark’s Beijing-based analyst on the Chinese market.',
    img: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto:best,w_700/v1747758202/assets/newsletter/copper-newsletter_xrfrbv.png',
    alt: 'Copper Weekly Newsletter',
  },
]

export const OUR_DIVISIONS = [
  {
    title: 'Prices',
    icon: 'Pricing',
    url: `/${PRICE_ASSESSMENTS.slug}`,
    description: 'The world’s most trusted PRA for future facing commodities',
  },
  {
    title: 'Data',
    icon: 'Data',
    url: `/${MARKET_ASSESSMENTS.slug}`,
    description:
      'Unrivalled, granular supply chain data, regularly reassessed and refreshed',
  },
  {
    title: 'Forecasts',
    icon: 'about/forecast',
    url: `/${FORECASTS.slug}`,
    description:
      'The most extensive supply chain forecasts databases, from mine to EV',
  },
  {
    title: 'Consultancy',
    icon: 'about/consultancy',
    url: '/consultancy',
    description:
      'Bespoke research from the world’s experts, backed by Benchmark’s proprietary data',
  },
  {
    title: 'Sustainability',
    icon: 'about/sustainability',
    url: `/sustainability`,
    description:
      'Industry-first life cycle assessments, risk metrics, and ESG advisory',
  },
  {
    title: 'Benchmark Source',
    icon: 'about/source',
    url: '',
    description: 'Your gateway to Benchmark Mineral Intelligence',
  },
  {
    title: 'Events',
    icon: 'about/events',
    url: '/events',
    description:
      'Dealmaking & networking with Benchmark’s community - worldwide',
  },
  {
    title: 'Team Benchmark',
    icon: 'about/team',
    url: '/join-us',
    description:
      'We have a truly global and expanding operation. Join Team Benchmark ',
  },
]

export const PRICE_SPOTLIGHT_SENTENCES = [
  [
    'Lithium Carbonate China',
    'Lithium Carbonate ROW',
    'Cobalt Chemical',
    'Nickel Sulphate',
    'Flake Graphite',
    'Synthetic Graphite',
  ],
  [
    'Cathode',
    'Anode',
    'Lithium ion Batteries',
    'Rare Earths',
    'Copper',
    'Black Mass',
    'Manganese',
  ],
]

export const COPPER_WEEKLY_SENTENCES = [
  'Understand the latest copper price drivers and Benchmark’s near-term price outlook',
  "Holistic view of copper's role in the evolving energy transition landscape",
  'Keep up to date with the latest news from across the copper industry',
  'Stay on top of copper’s key submarkets: concentrate, blister/anode, cathode and scrap',
  'Get first-hand accounts of the China market from Benchmark’s Beijing-based analyst',
  'Gain exclusive access to Benchmark’s insights and analysis on pertinent market issues',
  'Keep track of key high-frequency copper market indicators',
]

export const PRECURSOR_ASSESSMENT = {
  slug: 'precursor-assessment',
  slugForecast: 'precursor',
  name: 'Precursor Cathode Active Material Assessment',
  simplifiedName: 'Precursor Cathode Active Material Assessment',
  capacityName: 'Precursor',
  capacitySlug: 'precursor',
  checkbox: 'precursor',
  category: 'gigafactory',
  categoryReportPricing: 'precursor',
  categoryReportForecast: null,
  mineralId: null,
  menu: 'Precursor Assessment',
  sidebar: 'Precursor',
  iconLine: 'Precursor',
  iconColor: 'precursor-assessment-logo',
  unauthorizedTitle: 'Precursor Cathode Active Material Assessment',
  seo: {
    priceAssessments: {
      reportDescription:
        'Find every Precursor Cathode Active Material Price Assessment report obtained by the Benchmark Mineral Intelligence in the past weeks or months.',
    },
    marketAssessments: {
      reportDescription:
        'Find every Precursor Cathode Active Material Market Assessment report obtained by the Benchmark Mineral Intelligence in the past weeks or months.',
      capacities:
        'Headquartered: Download chart as image Gigafactory Producers: Total Capacity Pipeline: tpa',
    },
  },
} as const

export const POLICY_NEWSLETTER_SENTENCES = [
  'Get timely updates on government policies and decisions',
  'Access expert analyses and opinions',
  'Simplified infographics for easy comprehension',
  'Personalised newsletters based on your interests',
]

export const BENCHMARK_API = {
  slug: 'api',
  name: 'Benchmark API',
} as const

export const BENCHMARK_APP = {
  slug: 'app',
  name: 'Benchmark App',
} as const

export const MARKETS_WITH_SUSTAINABILITY_INDEX = [
  LITHIUM,
  COBALT,
  NICKEL,
  NATURAL_GRAPHITE,
  SYNTHETIC_GRAPHITE,
  RARE_EARTHS,
  LITHIUM_ION_BATTERIES,
] as const

export const MARKETS_WITH_PRICE_ANALYSIS = [
  LITHIUM,
  COBALT,
  NICKEL,
  NATURAL_GRAPHITE,
  SYNTHETIC_GRAPHITE,
  RARE_EARTHS,
  RECYCLING,
] as const

export const MARKETS_WITH_INDEX_OR_PRICES = [
  ...MARKETS_WITH_SUSTAINABILITY_INDEX,
  ANODE,
  CATHODE,
  LITHIUM_ION_BATTERIES,
  RECYCLING,
] as const

export const ALL_MARKETS = [
  ...MARKETS_WITH_INDEX_OR_PRICES,
  COPPER,
  MANGANESE,
  PHOSPHATE,
  FLUORSPAR,
  SILICON_ANODE,
  NEW_TECHNOLOGY,
] as const

export const DAILY_PRICE_INDICATOR = 'Daily Price Indicator'
